export class ValidationSummaryReportData {
    ProjectID?: number;
    ProjectTitle?: string;
    VendorID?: number;
}